import React from "react";
import { func, node, oneOf, oneOfType, string } from "prop-types";
import cx from "classnames";
import { Button } from "@chaser/components";
import style from "./UpgradeOverlay.module.scss";
import { useFeatureContext } from "./featureContext";
import FeatureGateCTA from "./FeatureGateCTA";
import LockIconBadge from "../LockIconBadge";
import useTrialExpiry from "@/hooks/useTrialExpired";

const UpgradeOverlay = ({
  children,
  text = "Upgrade to take advantage of this feature",
  buttonText = "View plans",
  type = "hide",
}) => {
  const { isInTrial } = useTrialExpiry();
  const ctx = useFeatureContext();
  if (ctx.canAccess) return children;

  if (ctx.sandbox) {
    text = "Connect to take advantage of this feature";
    buttonText = "Connect";
  }

  if (type === "hide-locked" || type === "hide-locked-minimal") {
    return (
      <div
        className={style.lockedContainer}
        style={{
          position: "relative",
          width: "fit-content",
          paddingRight: "15px",
        }}
      >
        <Button
          appearance={type === "hide-locked-minimal" ? "minimal" : "secondary"}
          size="narrow"
          onClick={ctx.onUpgrade}
        >
          Upgrade
        </Button>
        <LockIconBadge offset={{ position: "absolute", right: -5, top: -5 }} />
      </div>
    );
  }

  if ((ctx.hasAddons || type === "locked") && children) {
    const childArray = React.Children.toArray(children);
    const hasMultipleChildren = childArray.length > 1;

    const overrideType = isInTrial ? "locked" : type;

    return (
      <div
        className={style.lockedContainer}
        style={{ position: "relative", height: "100%" }}
      >
        <div className={style.lockedContent}>
          {hasMultipleChildren ? (
            <div onClick={ctx.onUpgrade} style={{ height: "100%" }}>
              {children}
            </div>
          ) : (
            React.cloneElement(children, { onClick: ctx.onUpgrade })
          )}
        </div>
        <LockIconBadge offset={{ position: "absolute", right: -5, top: -5 }} />
      </div>
    );
  }

  return (
    <>
      <div className={cx(style.wrapper, style[type])}>
        {type === "tease" && (
          <FeatureGateCTA
            text={text}
            buttonText={buttonText}
            className={style.cta}
          />
        )}
        <div className={style.content}>
          {type !== "hide" &&
            (typeof children === "function" ? children(ctx) : children)}
        </div>
        <div className={style.overlay}></div>
      </div>
      {type !== "tease" && (
        <FeatureGateCTA text={text} buttonText={buttonText} />
      )}
    </>
  );
};

UpgradeOverlay.propTypes = {
  children: oneOfType([node, func]).isRequired,
  text: string,
  type: oneOf(["tease", "hide"]),
};

export default UpgradeOverlay;
